// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3gszD","footer":"ReportModalFilter_footer__3HSqU"};